import React from 'react';
import { DatabaseIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function OwnerFinderPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-3879">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3880">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3881">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-3882">
            Simple pricing to find{' '}
            <span className="text-blue-600" data-id="element-3883">business owner</span> contacts
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-3884">
            Find local business owners without enterprise contracts or hidden
            fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-3885">
          {/* Search Owners */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-3886">
            <div className="flex items-center gap-3 mb-4" data-id="element-3887">
              <DatabaseIcon className="w-5 h-5 text-slate-400" data-id="element-3888" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-3889">
                Search local business owners
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-3890">
              Search and filter local business owner records by industry and
              location.
            </p>
            <div data-id="element-3891">
              <div className="flex items-baseline gap-2" data-id="element-3892">
                <span className="text-4xl font-bold text-slate-900" data-id="element-3893">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3894">unlimited searches</p>
            </div>
          </div>

          {/* Owner Emails */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-3895">
            <div className="flex items-center gap-3 mb-4" data-id="element-3896">
              <MailIcon className="w-5 h-5 text-slate-400" data-id="element-3897" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-3898">
                Local business owner emails
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-3899">
              Get verified email addresses for local business owners and
              decision-makers.
            </p>
            <div data-id="element-3900">
              <div className="flex items-baseline gap-2" data-id="element-3901">
                <span className="text-4xl font-bold text-slate-900" data-id="element-3902">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3903">
                per 100 emails found
              </p>
            </div>
          </div>

          {/* Employee Phones */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-3904">
            <div className="flex items-center gap-3 mb-4" data-id="element-3905">
              <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-3906" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-3907">
                Business owner direct phones
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-3908">
              Access direct dial and mobile numbers for business owner contacts.
            </p>
            <div data-id="element-3909">
              <div className="flex items-baseline gap-2" data-id="element-3910">
                <span className="text-4xl font-bold text-slate-900" data-id="element-3911">$24</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3912">
                per 100 phones found
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-3913">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-3914">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-3915" />
            <span data-id="element-3916">Pay only for valid results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-3917">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-3918" />
            <span data-id="element-3919">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-3920">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-3921" />
            <span data-id="element-3922">No credit card required</span>
          </div>
        </div>

        <div className="text-center" data-id="element-3923">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-3924">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-3925">
              Try for free
            </a>
          </div>
        </div>
      </div>
    </section>;
}